import { render, staticRenderFns } from "./FideicomisoGarantias.vue?vue&type=template&id=0ca608f8&scoped=true"
import script from "./FideicomisoGarantias.vue?vue&type=script&lang=js"
export * from "./FideicomisoGarantias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca608f8",
  null
  
)

export default component.exports